import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from './../dynamic-form/dynamic-form.component';
import { FidelidadeService } from './../../../_services/fidelidade.service';
import { FieldConfig } from '../../../_models/field.interface';
import * as moment from 'moment';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-pontos-expirar',
  templateUrl: './pontos-expirar.component.html',
  styleUrls: ['./pontos-expirar.component.scss'],
})
export class PontosExpirarComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  regLabelsPontosAExpirar: FieldConfig[];
  regLabelsEconomizados: FieldConfig[];

  constructor(private fidelidadeService: FidelidadeService) {}

  ngOnInit(): void {
    this.exibirPontosAExpirar(0, '');
    this.exibirSaldoDePontos('R$0,00');

    this.obterTransacaoAExpirar();
    this.obterSaldoDePontos();
  }

  exibirPontosAExpirar(valor: number, data: string) {
    let currencyPipe: CurrencyPipe = new CurrencyPipe('pt-BR');
    var dataReplaced = data.split('-').join('/');
    data = dataReplaced;

    if (valor == undefined) valor = 0;

    const cashback = currencyPipe.transform(valor, 'pt-BR', 'R$');

    this.regLabelsPontosAExpirar = [
      {
        type: 'label',
        label: 'Cashback a expirar:',
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '400',
            'font-size': '0.8rem',
            color: '#fff',
            'margin-bottom': '-0.6rem',
            'margin-top': '1rem',
          };
        },
        onClick(): void {},
      },
      {
        type: 'label',
        label: `${cashback}`,
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '700',
            'font-size': '1.5rem',
            color: '#fff',
            'margin-bottom': '-0.6rem',
          };
        },
        onClick(): void {},
      },
      {
        type: 'label',
        label: ``,
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '400',
            'font-size': '0.8rem',
            color: '#fff',
            'margin-bottom': '0rem',
          };
        },
        onClick(): void {},
      },
    ];

    if (valor > 0) {
      this.regLabelsPontosAExpirar[
        this.regLabelsPontosAExpirar.length - 1
      ].label = `Valido até: ${data}`;
    }
  }

  obterTransacaoAExpirar() {
    this.fidelidadeService.obterTransacaoAExpirar().subscribe(
      (sucesso) => {
        this.processarSucessoPontosAExpirar(sucesso);
      },
      (falha) => {
        this.processarFalhaPontosAExpirar(falha);
      }
    );
  }

  processarSucessoPontosAExpirar(response: any) {
    const data = moment(response.validade).format('DD-MM-yyyy');

    this.exibirPontosAExpirar(response.saldoCashback, data);
  }

  processarFalhaPontosAExpirar(fail: any) {
    this.exibirPontosAExpirar(0, '');
  }

  // ***********************/
  // Saldo
  //************************/
  exibirSaldoDePontos(saldo: string) {
    this.regLabelsEconomizados = [
      {
        type: 'label',
        label: 'Cashback total:',
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '400',
            'font-size': '0.8rem',
            color: '#461F1A',
            'margin-bottom': '-0.6rem',
            'margin-top': '1rem',
          };
        },
        onClick(): void {},
      },
      {
        type: 'label',
        label: `${saldo}`,
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '700',
            'font-size': '1.5rem',
            color: '#461F1A',
          };
        },
        onClick(): void {},
      },
    ];
  }

  obterSaldoDePontos() {
    this.fidelidadeService.obterMembro().subscribe(
      (sucesso) => {
        this.processarSucessoSaldoDePontos(sucesso);
      },
      (falha) => {
        this.processarFalhaSaldoDePontos(falha);
      }
    );
  }

  processarSucessoSaldoDePontos(response: any) {
    let currencyPipe: CurrencyPipe = new CurrencyPipe('pt-BR');

    let valor = response.saldo.saldoCashback;
    if (valor == undefined) valor = 0;

    const cashback = currencyPipe.transform(valor, 'pt-BR', 'R$');
    this.exibirSaldoDePontos(cashback);
  }

  processarFalhaSaldoDePontos(fail: any) {
    this.exibirSaldoDePontos('R$0,00');
  }
}
